/* LTHR cart drawer: monogram upsell (CRO edit 4).
   Markup comes from snippets/ntd-cart-monogram.liquid, rendered per eligible
   line inside the drawer. Dawn swaps the drawer's innerHTML on every cart
   change, so every listener here is delegated at document level and nothing
   holds a reference to drawer nodes between events.

   Submit order mirrors the PDP block (snippets/ntd-monogram.liquid):
     1. POST /cart/add.js    the $10 add-on line, quantity == the item line,
                             properties {Monogram for, Initials, Placement}
     2. POST /cart/change.js the item line by key, existing properties plus
                             "Monogram initials" / "Monogram placement",
                             asking for the drawer sections back
     3. cart-drawer.renderContents(state) + publish cartUpdate
   If step 2 fails, the add-on from step 1 is rolled back so we never charge
   for a monogram that is not on an item. Loaded once from cart-drawer.liquid;
   the init flag guards a second include. */
(function () {
  if (window.ntdCartInit) return;
  window.ntdCartInit = true;

  var INITIALS = /^[A-Z]{2,3}$/;
  var ERROR_TEXT = 'Sorry, the monogram could not be added just now. Please try again.';
  var INVALID_TEXT = 'Enter 2 or 3 letters';

  function routeFor(name, fallback) {
    return (window.routes && window.routes[name]) || fallback;
  }

  function closestBlock(el) {
    return el && el.closest ? el.closest('[data-ntd-cart-mono]') : null;
  }

  function findBlock(lineKey) {
    var blocks = document.querySelectorAll('[data-ntd-cart-mono]');
    for (var i = 0; i < blocks.length; i++) {
      if (blocks[i].dataset.lineKey === lineKey) return blocks[i];
    }
    return null;
  }

  /* Same normalisation as the PDP block: letters only, uppercase, max 3. */
  function cleanInitials(input) {
    var value = input.value.toUpperCase().replace(/[^A-Z]/g, '').slice(0, 3);
    if (value !== input.value) input.value = value;
    return value;
  }

  function setBusy(block, busy) {
    if (!block) return;
    block.dataset.busy = busy ? 'true' : 'false';
    var btn = block.querySelector('[data-ntd-cart-mono-submit]');
    if (!btn) return;
    btn.classList.toggle('loading', busy);
    btn.toggleAttribute('disabled', busy);
    btn.setAttribute('aria-busy', busy ? 'true' : 'false');
    var spinner = btn.querySelector('.loading__spinner');
    if (spinner) spinner.classList.toggle('hidden', !busy);
  }

  function showError(block, message) {
    if (!block) return;
    var el = block.querySelector('[data-ntd-cart-mono-error]');
    if (!el) return;
    el.textContent = message || '';
    el.hidden = !message;
    if (message) block.open = true;
  }

  function postJson(url, body) {
    var config =
      typeof fetchConfig === 'function'
        ? fetchConfig()
        : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
    config.body = JSON.stringify(body);
    return fetch(url, config).then(function (res) {
      return res
        .json()
        .catch(function () {
          return {};
        })
        .then(function (data) {
          /* Cart API errors come back as 422 with {status, message, description}. */
          if (!res.ok || (data && typeof data.status === 'number' && data.status >= 400)) {
            var err = new Error((data && (data.description || data.message)) || 'Request failed: ' + res.status);
            err.data = data;
            throw err;
          }
          return data;
        });
    });
  }

  function drawerSections(drawer) {
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      return drawer.getSectionsToRender().map(function (section) {
        return section.id;
      });
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function publishCartUpdate(state) {
    if (typeof publish !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return Promise.resolve();
    return publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ntd-cart', cartData: state });
  }

  /* Undo step 1 when step 2 fails. Re-read the cart first: add.js may have
     merged into an existing add-on line, so subtract only what we added. */
  function rollbackAddon(addonKey, quantity) {
    return fetch(routeFor('cart_url', '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var line = (cart.items || []).filter(function (item) {
          return item.key === addonKey;
        })[0];
        if (!line) return null;
        var remaining = Math.max(0, line.quantity - quantity);
        return postJson(routeFor('cart_change_url', '/cart/change.js'), { id: addonKey, quantity: remaining });
      })
      .catch(function (e) {
        console.error('[ntd-cart] add-on rollback failed', e);
      });
  }

  async function addMonogram(block) {
    if (!block || block.dataset.busy === 'true') return;

    var initialsInput = block.querySelector('[data-ntd-cart-mono-initials]');
    if (!initialsInput) return;
    var initials = cleanInitials(initialsInput);
    if (!INITIALS.test(initials)) {
      initialsInput.setCustomValidity(INVALID_TEXT);
      initialsInput.reportValidity();
      return;
    }
    initialsInput.setCustomValidity('');

    var placementEl = block.querySelector(
      '[data-ntd-cart-mono-placement]:checked, input[type="hidden"][data-ntd-cart-mono-placement]'
    );
    var placement = placementEl ? placementEl.value : '';
    var lineKey = block.dataset.lineKey;
    var quantity = parseInt(block.dataset.lineQuantity, 10) || 1;
    var addonId = Number(block.dataset.addonVariant);
    var itemTitle = block.dataset.itemTitle || '';
    if (!lineKey || !addonId) return;

    /* Liquid serialises line_item.properties as an array of [name, value]
       pairs; older data may already be an object. Normalise to an object so
       /cart/change receives a hash (an array is a 400 Bad Request). */
    var properties = {};
    try {
      var rawProps = JSON.parse(block.dataset.properties || '{}');
      if (Array.isArray(rawProps)) {
        rawProps.forEach(function (pair) {
          if (pair && pair.length === 2 && pair[0]) properties[pair[0]] = pair[1];
        });
      } else if (rawProps && typeof rawProps === 'object') {
        properties = rawProps;
      }
    } catch (e) {
      properties = {};
    }
    properties['Monogram initials'] = initials;
    properties['Monogram placement'] = placement;

    var drawer = document.querySelector('cart-drawer');
    var sections = drawerSections(drawer);

    setBusy(block, true);
    showError(block, '');

    var addonKey = null;
    try {
      /* 1. Charge first: the same payload the PDP block sends. */
      var added = await postJson(routeFor('cart_add_url', '/cart/add.js'), {
        items: [
          {
            id: addonId,
            quantity: quantity,
            properties: { 'Monogram for': itemTitle, Initials: initials, Placement: placement },
          },
        ],
      });
      if (added && added.items && added.items[0]) {
        addonKey = added.items[0].key;
      } else if (added && added.key) {
        addonKey = added.key;
      }

      /* 2. Put the initials on the item's own line. */
      var state = await postJson(routeFor('cart_change_url', '/cart/change.js'), {
        id: lineKey,
        quantity: quantity,
        properties: properties,
        sections: sections.join(','),
        sections_url: window.location.pathname,
      });

      /* 3. Re-render through Dawn's path so rows, totals and badge move together. */
      if (drawer && typeof drawer.renderContents === 'function' && state && state.sections) {
        drawer.renderContents(state);
      }
      publishCartUpdate(state);
    } catch (err) {
      console.error('[ntd-cart] monogram upsell failed', err);
      if (addonKey) {
        await rollbackAddon(addonKey, quantity);
        /* The drawer may now be out of step with the cart: let Dawn re-sync it. */
        try {
          await publishCartUpdate();
        } catch (e) {
          /* keep going: the error still needs showing */
        }
      }
      var live = findBlock(lineKey) || block;
      setBusy(live, false);
      showError(live, ERROR_TEXT);
    }
  }

  /* Dawn's cart-drawer-items treats every bubbling 'change' inside it as a
     quantity edit (validateQuantity -> updateQuantity with an undefined line,
     a 400 and a TypeError in resetQuantityInput). Our initials field and
     placement radios live inside that element, so keep their change events
     from reaching it. Defaults (the radio check) are untouched. */
  document.addEventListener(
    'change',
    function (event) {
      if (closestBlock(event.target)) event.stopPropagation();
    },
    true
  );

  document.addEventListener('input', function (event) {
    var input = event.target;
    if (!input || !input.matches || !input.matches('[data-ntd-cart-mono-initials]')) return;
    cleanInitials(input);
    input.setCustomValidity('');
  });

  /* Enter in the initials field adds the monogram for that line. */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    var input = event.target;
    if (!input || !input.matches || !input.matches('[data-ntd-cart-mono-initials]')) return;
    event.preventDefault();
    addMonogram(closestBlock(input));
  });

  /* The owner form exists only to keep the controls out of CartDrawer-Form. */
  document.addEventListener('submit', function (event) {
    if (event.target && event.target.id === 'NtdCartMonogramForm') event.preventDefault();
  });

  document.addEventListener('click', function (event) {
    var btn = event.target && event.target.closest ? event.target.closest('[data-ntd-cart-mono-submit]') : null;
    if (!btn) return;
    event.preventDefault();
    addMonogram(closestBlock(btn));
  });

  /* CRO-13: one-tap keychain add-on (snippets/ntd-cart-keychain.liquid).
     /cart/add.js with sections returns the drawer markup in one round trip,
     the same call Dawn's product form makes; render through renderContents so
     rows, totals and the badge move together and the row itself disappears
     (the snippet renders nothing once the keychain is in the cart). */
  async function addKeychain(btn) {
    var wrap = btn.closest('[data-ntd-cart-addon]');
    var variantId = Number(btn.dataset.ntdCartAddonAdd);
    if (!variantId || btn.disabled) return;
    var drawer = document.querySelector('cart-drawer');
    var sections = drawerSections(drawer);
    var errorEl = wrap ? wrap.querySelector('[data-ntd-cart-addon-error]') : null;
    btn.disabled = true;
    btn.classList.add('loading');
    var spinner = btn.querySelector('.loading__spinner');
    if (spinner) spinner.classList.remove('hidden');
    if (errorEl) errorEl.hidden = true;
    try {
      var state = await postJson(routeFor('cart_add_url', '/cart/add.js'), {
        items: [{ id: variantId, quantity: 1 }],
        sections: sections.join(','),
        sections_url: window.location.pathname,
      });
      if (drawer && typeof drawer.renderContents === 'function' && state && state.sections) {
        drawer.renderContents(state);
      }
      publishCartUpdate(state);
    } catch (err) {
      console.error('[ntd-cart] keychain add-on failed', err);
      btn.disabled = false;
      btn.classList.remove('loading');
      if (spinner) spinner.classList.add('hidden');
      if (errorEl) {
        errorEl.textContent = 'Sorry, that could not be added just now. Please try again.';
        errorEl.hidden = false;
      }
    }
  }

  document.addEventListener('click', function (event) {
    var btn = event.target && event.target.closest ? event.target.closest('[data-ntd-cart-addon-add]') : null;
    if (!btn) return;
    event.preventDefault();
    addKeychain(btn);
  });

  /* 2026-10-19: a tap on the add-on's title adds it with the
     first colour button (Brown), the same as tapping that button (Clarity:
     22 dead taps on the title). */
  document.addEventListener('click', function (event) {
    var hit = event.target && event.target.closest ? event.target.closest('[data-ntd-cart-addon-default]') : null;
    if (!hit) return;
    var wrap = hit.closest('[data-ntd-cart-addon]');
    var btn = wrap ? wrap.querySelector('[data-ntd-cart-addon-add]') : null;
    if (!btn) return;
    event.preventDefault();
    addKeychain(btn);
  });
})();
